import React, { useState } from 'react'
import { Link, matchPath, NavLink, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo/biam_black.svg';
import logo_orange from '../../assets/images/logo/biam_tangerine.svg';

const Header = () => {

    const location = useLocation();

    // Styles spécifiques selon les routes
    const footerStyles = {
        "/": "",
        "/about": "",
        "/team": "",
        "/culture": "",
        "/work": "",
        "/blog": "",
        "/contact": "",
    };

    // Vérifier si l'URL correspond à "/work/project/:id"
    const isProjectPage = matchPath("/work/project/:id", location.pathname);
    const isAboutPage = matchPath("/about", location.pathname);
    const isContactPage = matchPath("/contact", location.pathname);
    const isTcsPage = matchPath("/tcs", location.pathname);
    const isWeAreHiringPage = matchPath("/wearehiring", location.pathname);

    // Déterminer le style final du footer
    const currentStyle = isProjectPage || isAboutPage || isContactPage || isTcsPage || isWeAreHiringPage ? "text-black" : footerStyles[location.pathname] || "text-white";

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const activeSidenavLinkCss = `flex items-center cursor-pointer text-[14px] font-bold text-tangerine`;
    const sidenavLinkCss = 'flex items-center cursor-pointer text-[14px]';

    const sidebarList = [
        {
            label: 'ABOUT US',
            link: '/about',
        },
        {
            label: 'WORK',
            link: '/work',
        },
        {
            label: 'MEDIA',
            link: '/media',
        },
        {
            label: 'CONTACT',
            link: '/contact',
        },
    ];

    const isActiveLink = (path) => {
        if (path === '/media') {
            return location.pathname.startsWith('/media');
        }
        if (path === '/work') {
            return location.pathname.startsWith('/work');
        }
        if (path === '/wearehiring') {
            return location.pathname.startsWith('/wearehiring');
        }
        return location.pathname === path;
    };


    return (
        <>
            <section className="">
                <div
                    className={`lg:flex hidden items-center justify-between z-[999] p-[1.25rem] w-full fixed top-0 left-1/2 -translate-x-1/2 ppmori uppercase ${currentStyle}`}
                >
                    {sidebarList.map((list, idx) => (
                        <NavLink
                            key={idx}
                            to={list.link}
                            className={isActiveLink(list.link) ? activeSidenavLinkCss : sidenavLinkCss}
                        >
                            {list.label}
                        </NavLink>
                    ))}
                </div>
            </section>

            <section
                className={`lg:hidden w-full flex flex-col gap-[15px] z-[999] ${isOpen
                    ? "fixed top-0 left-0 h-[100dvh] overflow-y-scroll ppmori bg-black animate-slide-in"
                    : "animate-slide-out"
                    }`}
            >
                {/* Header Top */}
                <div
                    className={`flex justify-between items-center p-[1.25rem] shadow-md w-full ${isOpen ? "" : "fixed bg-white"
                        }`}
                    id="mobileNav"
                >
                    <Link
                        to="/"
                        onClick={closeMenu}
                        className={isOpen ? "w-full justify-center items-center flex" : ""}
                    >
                        <img
                            src={isOpen ? logo_orange : logo}
                            className={`transition-all duration-300 ${isOpen ? "h-[30px]" : "h-[20px]"
                                }`}
                            alt="BIAM"
                        />
                    </Link>

                    {!isOpen && (
                        <span
                            className="text-black text-[18px] font-bold transition-all duration-300 hover:translate-x-1 cursor-pointer"
                            onClick={toggleMenu}
                        >
                            → MENU
                        </span>
                    )}
                </div>

                {/* Menu Content */}
                {isOpen && (
                    <div className="flex flex-col text-tangerine bg-black justify-between h-full transition-all helvetica">
                        <div className="flex flex-col w-full font-bold border-t-2 border-tangerine">

                            <NavLink
                                to={"/"}
                                className={`flex flex-col justify-center items-center border-b-2 border-tangerine py-[25px] text-[28px] text-center uppercase ${isActiveLink("/")
                                    ? "text-white"
                                    : "text-tangerine font-bold"
                                    }`}
                                onClick={closeMenu}
                            >
                                HOME
                            </NavLink>

                            {sidebarList.map((item, idx) => (
                                <NavLink
                                    key={idx}
                                    to={item.link}
                                    className={`flex flex-col justify-center items-center border-b-2 border-tangerine py-[25px] text-[28px] text-center uppercase ${isActiveLink(item.link)
                                        ? "text-white"
                                        : "text-tangerine font-bold"
                                        }`}
                                    onClick={closeMenu}
                                >
                                    {item.label}
                                </NavLink>
                            ))}
                        </div>

                        <div>
                            <p
                                className="text-tangerine text-[24px] pb-5 text-center font-bold cursor-pointer"
                                onClick={toggleMenu}
                            >
                                X CLOSE
                            </p>
                        </div>
                    </div>
                )}
            </section>
        </>
    )
}

export default Header